module.exports = __webpack_public_path__ + "static/media/logo.5c72d426.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 1227
// module chunks = 0